export const popupSortingEnum = {
  noticeReadTime: { sorting: 1 },
  eventPopupTime: { sorting: 2 },
  redEnvelopePopupTime: { sorting: 3 },
  dailyCheckTime: { sorting: 4 },
};
